const user_scopes = {
    descriptions: {
        custom_data: 'Tus datos personalizados',
        email: 'Tu dirección de correo electrónico',
        phone: 'Tu número de teléfono',
        profile: 'Tu nombre, nombre de usuario, avatar y otra información de perfil',
        roles: 'Tus roles',
        groups: 'Tus grupos',
        identities: 'Tus identidades sociales vinculadas',
        'urn:logto:scope:organizations': 'La información sobre tus organizaciones',
        'urn:logto:scope:organization_roles': 'Tus roles en la organización',
        address: 'Tu dirección',
        /** UNTRANSLATED */
        'urn:logto:scope:sessions': 'Your active sessions',
    },
};
export default Object.freeze(user_scopes);
